
import { Vue, Component } from 'vue-property-decorator'
import DashboardAudition from '../../components/Dashboards/DashboardAudition.vue'
  @Component({
    components: { DashboardAudition }
  })
export default class baohe extends Vue {
  mounted() {}
}
